/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Converts strings to camelCase
 */

export const toCamelCase = (str: string) => {
  if (!str) {
    return ''
  }
  if (!str.match(/[a-z]+/g)) {
    return str
  }
  return (
    str
      // trim the leading & trailing snake characters
      .replace(/^[\s_-]+|[\s_-]+$/g, '')
      // change -(t)hing to (T)hing
      .replace(/(?:[\s_-]+)(\w)/g, (match, p1) => p1.toUpperCase())
      // lowercase the first letter
      .replace(/^[A-Z]/, (s) => s.toLowerCase())
  )
}
